import React, {useState} from "react";

function Dropdown({thingsList = [], selectedThing, setSelectedThing, additionalClassName }) {

  const [dropdownClick, setDropdownClick] = useState(false);

  return (
    <div className={`dropdown ${additionalClassName}`}>
      <button className="dropdown-btn" onClick={() => setDropdownClick(!dropdownClick)}>
        {selectedThing}
        <i className="mdi mdi-chevron-down"/>
      </button>
      {
        dropdownClick &&
        <ul>
          {
            thingsList.map((thing) => <li onClick={() => {setSelectedThing(thing); setDropdownClick(!dropdownClick)}}>{thing}</li>)
          }
        </ul>
      }
    </div>
  );
}

export default Dropdown;
